__turbopack_context__.v({
  "border": "cDkATW_border",
  "cssFrame": "cDkATW_cssFrame",
  "decorationOnly": "cDkATW_decorationOnly",
  "glow": "cDkATW_glow",
  "texture": "cDkATW_texture",
  "wrapper": "cDkATW_wrapper",
});
